import { Typography } from '@navi/web-ui/lib/primitives';

interface IInputDataContainerProps {
  leftLabel: string;
  rightLabel: string;
  icon?: React.ReactNode;
}

const InputDataContainer = (props: IInputDataContainerProps) => {
  const { leftLabel, rightLabel, icon } = props;
  return (
    <>
      <Typography variant="h6" color="var(--grayscale-content-3)">
        {leftLabel}
      </Typography>
      <div className="flex items-center gap-2">
        {icon ? icon : null}
        <Typography variant="h4" color="var(--grayscale-2)">
          {rightLabel}
        </Typography>
      </div>
    </>
  );
};

export default InputDataContainer;
